import { AskQuestionForm } from '@/components/ask-question-form';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { QuestionInfoType } from '@/types/api/question';
import { useRouter } from 'next/navigation';
import React from 'react';

interface CreateDiscussionQuestionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  questionInfo?: QuestionInfoType;
}

export const CreateDiscussionQuestionDialog = ({
  open,
  onOpenChange,
  questionInfo,
}: CreateDiscussionQuestionDialogProps) => {
  const router = useRouter();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="min-w-[800px]">
        <DialogTitle className="text-XL font-bold">
          Start a discussion
        </DialogTitle>
        <AskQuestionForm
          isModal
          isDiscussion
          defaultQuestionInfo={questionInfo}
          onSuccess={(data) => {
            onOpenChange(false);
            if (data) {
              router.push(`/discussions/question/${data.slug}`);
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
